import "./LoadingOverlay.scss";
import LoadingSpinner from "../loading-spin/LoadingSpinner";

interface LoadingOverlayProps {
  message?: string;
}

export default function LoadingOverlay({ message }: LoadingOverlayProps) {
  return (
    <div className="loading-overlay">
      <div className="loading-overlay__content">
        <LoadingSpinner />
        {message && <p className="loading-overlay__message">{message}</p>}
      </div>
    </div>
  );
}
